
import rendererCommons from "@/components/UserInterfaces/renderer/mixins/renderer-commons";
import { __generateData } from "@/assets/js/Renderer/generatorsFns";

export default {
    name: "NamespaceRenderer",
    mixins: [rendererCommons],
    data() {
        return {
        };
    },
    computed: {
    },
    methods: {
        addIndexToPath(index) {
            return [...this.localPath, index];
        },
        onAdd() {
            const { components, properties } = this.$store.state.components;
            const emptyBody = __generateData(this.component.body, { properties, components });

            this.componentData.push({ __ns: this.$generateUID(), ...emptyBody });
        },
        canLoad(props, iterationIndex) {
            const { activeIndex = -1 } = props || {};

            return (activeIndex === -1) || (activeIndex - 1 === iterationIndex);
        },
        getNamespaceStr(idx) {
            return this.componentData[idx].__ns;
        }
    }
};
